<script setup>
  import {reactive, onMounted, onUnmounted, computed} from "vue";
  import {ApiWrapper} from "@/Utils/ApiWrapper";
  import {Permissions} from "@/Utils/Permissions";
  import {activeComponentStore} from "@/Stores/ActiveComponentStore";
  import {ToastUtil} from "@/Utils/ToastUtil";
  const compName = 'ClientTimelineComponent';

  const props = defineProps({
    contextSchemaA: String,
    contextIdA: String
  });

  const data = reactive({
    ALL_FILTERS: ["note", "message", "task", "generic", "file"],
    currentUser: '',
    selectedFilters: [],
    timelineData: [],
    notes: [],
    show: [],
    openAdditionalNoteForm: false,
    loading: false,
    loadingButton: false,
    loadingDelete: false
  });

  const deleteItem = (item) => {
    let deleteNote = confirm(
        'Are you sure you want to delete this item?'
    )
    if (deleteNote === true) {
      item.isDeleting = true
      ApiWrapper.post('notes', 'delete-note', {
            item: item,
            claimId: props.contextIdA
          })
          .then((response) => {
            activeComponentStore.notifyComponents(['notes'],compName);
            loadData()
            ToastUtil.successMsg('Deleted note');
          })
          .catch((err) => {
            ToastUtil.error(err);
            item.isDeleting = false;
          })
    }
  }

  const formatTimestampByLocale = (timestamp) => {
    const date = new Date(timestamp)
    const timeOptions = {
      hour12: true,
      hour: "numeric",
      minute: "2-digit",
    }
    const dateOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZoneName:'short'
    }
    return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
  }

  const submitEditedNote = (item) => {
    data.loadingButton = true
    ApiWrapper.post('notes', 'edit-note', {
          editedItem: item
        })
        .then((response) => {
          item.isEditing = false
          data.loadingButton = false
          loadData()
          ToastUtil.successMsg('Updated note');
        })
        .catch((err) => {
          ToastUtil.error(err);
          item.isEditing = false
          data.loadingButton = false
        })
  }

  const submitMessage = (item) => {
    data.loading = true
    ApiWrapper.post('messaging', 'create-reply', {
          claimId: props.contextIdA,
          message: item.newMessage,
          oldmessageid: item.id,
          name: item.name,
        })
        .then((response) => {
          loadData()
          item.newMessage = ''
          data.loading = false
          ToastUtil.successMsg('Replied to message');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false
        })
  }

  const updateMessage = (item) => {
    data.loading = true
    item.is_read = true
    ApiWrapper.post('messaging', 'update-message', {
          id: item.mid,
          status: true,
        })
        .then((response) => {
          data.loading = false
          ToastUtil.successMsg('Updated message');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }

  const grabThumbnail = (item) => {
    if (item !== null && item !== '') {
      return 'data:image/jpeg;base64,' + item
    }
  }

  const loadData = () => {
    data.loading = true
    ApiWrapper.post('timeline', 'timeline', {
          method: 'loadData',
          claimId: props.contextIdA
        })
        .then((response) => {
          data.currentUser = response.curUser
          let timelineElement
          data.timelineData = []
          for (let i = 0; i < response.result.length; i++) {
            switch (response.result[i].type) {
              case 'file':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  id: response.result[i].id,
                  awsKey: response.result[i].body.awsKey,
                  smallthumbnail: response.result[i].body.smallthumbnail,
                  mediumthumbnail: response.result[i].body.mediumthumbnail,
                  uploadedBy: response.result[i].body.uploadedBy
                }
                break
              case 'history':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  id: response.result[i].id,
                  log: response.result[i].body.log,
                  username: response.result[i].body.username,
                  personname: response.result[i].body.personname,
                  timestamp: response.result[i].body.timestamp,
                }
                break
              case 'note':

                if( response.result[i].body?.isprivate) break;

                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  id: response.result[i].id,
                  isEditing: false,
                  note: response.result[i].body.note,
                  additionalinfo: response.result[i].body.additionalinfo,
                }
                break
              case 'message':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  id: response.result[i].id,
                  recipient: response.result[i].body.recipient,
                  is_read: response.result[i].body.is_read,
                  replyToMessage: false,
                  mid: response.result[i].body.mid,
                  key: response.result[i].key,
                  pid: response.result[i].body.pid,
                  message: response.result[i].body.message,
                }
                break
              case 'interaction':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  id: response.result[i].id,
                  claimcontact: response.result[i].body.claimcontact,
                  clientcontact: response.result[i].body.clientcontact,
                  interaction: response.result[i].body.interaction,
                  key: response.result[i].key,
                }
                break
              case 'task':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  clientDate: response.result[i].body.clientdate,
                  xactDate: response.result[i].body.xactdate,
                  thirdPartyDate: response.result[i].body.thirdpartydate,
                  id: response.result[i].id,
                  createdBy: response.result[i].body.createdBy,
                  additionalinfo: '',
                }
                switch (response.result[i].name) {
                  case 'Complete Inspection':
                    timelineElement.additionalinfo =
                        `Appointment completed at ` +
                        formatTimestampByLocale(response.result[i].body.formdata.datetime)
                    break
                  case 'Make Contact':
                    if(response.result[i].body.contactOutcome === 'No, left voicemail'){
                      timelineElement.additionalinfo =
                          `Voicemail left by ` +
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` at  ` + formatTimestampByLocale(response.result[i].time)
                    }else if(response.result[i].body.contactOutcome === 'No answer'){
                      timelineElement.additionalinfo =
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` called and received no answer at  ` + formatTimestampByLocale(response.result[i].time)
                    }else{
                      timelineElement.additionalinfo =
                          `Appointment set by ` +
                          response.result[i].body.createdBy +
                          ` to meet with ` +
                          response.result[i].body.persontomeet +
                          ` on  ` + formatTimestampByLocale(response.result[i].body.datetime)
                    }
                    break
                  case 'Recontact':
                    if(response.result[i].body.contactOutcome === 'No, left voicemail'){
                      timelineElement.additionalinfo =
                          `Voicemail left by ` +
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` at  ` + formatTimestampByLocale(response.result[i].time)
                    }else if(response.result[i].body.contactOutcome === 'No answer'){
                      timelineElement.additionalinfo =
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` called and received no answer at  ` + formatTimestampByLocale(response.result[i].time)
                    }else{
                      timelineElement.additionalinfo =
                          `Appointment set by ` +
                          response.result[i].body.createdBy +
                          ` to meet with ` +
                          response.result[i].body.persontomeet +
                          ` on  ` + formatTimestampByLocale(response.result[i].body.datetime)
                    }
                    break
                }
                break
            }
            data.timelineData.push(timelineElement)
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.loading = false;
        })
  }

  const condense = () => {
    for (let x in data.notes) {
      data.notes[x].type = 'note'
      data.timelineData.push(data.notes[x])
    }
    for (let x in data.generic) {
      data.generic[x].type = 'generic'
      data.timelineData.push(data.generic[x])
    }
    for (let x in data.messages) {
      data.messages[x].type = 'message'
      data.timelineData.push(data.messages[x])
    }

    for (let x in data.uploads) {
      data.uploads[x].type = 'upload'
      data.timelineData.push(data.uploads[x])
    }
    for (let x in data.tasks) {
      data.tasks[x].type = 'task'
      data.timelineData.push(data.tasks[x])
    }
  }

  const checkboxFilter = (type) => {
    if (data.selectedFilters.indexOf(type) === -1) {
      data.selectedFilters.push(type)
    } else {
      data.selectedFilters.splice(data.selectedFilters.indexOf(type), 1)
    }
  }

  const downloadFile = (item) => {
    ApiWrapper.post('timeline','timeline', {
      key: item.awsKey,
      method: 'downloadFile'
    })
    .then((response) => {
      window.open(response.url, "_blank");
    })
    .catch((error) => {
      ToastUtil.error(error);
    });
  }

  const toggleActive = (index) => {
    if (data.show.includes(index)) {
      data.show = data.show.filter((entry) => entry !== index)
      return
    }
    data.show.push(index)
  }

  onMounted(()=>{
    activeComponentStore.registerComponent(
        compName,
        [
          'files',
          'notes',
          'tasks',
          'messages',
          'claimstatusupdate'
        ],
        loadData
    );

    loadData()
    data.selectedFilters = ['note', 'message', 'task']
  })

  onUnmounted(() => {
    activeComponentStore.deregisterComponent(compName);
  });

  const filteredItems = computed(() => {
    return data.timelineData.filter((item) => {
      return Array.isArray(data.selectedFilters) && ((data.selectedFilters.indexOf(item.type) !== -1) || (data.selectedFilters.length === 0) || (data.selectedFilters.length === 1 && data.selectedFilters[0] === ''));
    });
  });
</script>

<template>
  <v-container>
    <v-toolbar-title>Client Timeline</v-toolbar-title>
    <div>
      <v-progress-linear
          :active="data.loading"
          :indeterminate="data.loading"
          color="primary"
      ></v-progress-linear>
    </div>
    <div>
      <v-timeline
          density="compact"
          align-top
          class="w-100"
          v-if="filteredItems.length > 0"
      >
        <v-timeline-item
            size="small"
            v-for="(item, index) in filteredItems"
            :key="item.key"
            color="primary"
        >
          <v-card v-if="item.type === 'note'" class="elevation-2 mr-4 w-100">
            <!-- <div v-if="item.loadingCircular === true" class="text-center">
              <v-progress-circular
                :active="loadingCircular"
                :indeterminate="loadingCircular"
                color="primary"
              ></v-progress-circular>
            </div> -->
            <div v-if="item.isEditing === false">
              <v-card-subtitle class="pb-0 pt-1">
                {{item.name}} created a note - {{formatTimestampByLocale(item.time)}}
              </v-card-subtitle>
              <p class="py-0 ml-4 mb-0 font-weight-medium p__text">
                <span class="note-span" v-html="item.note"></span>
                <span>
                        <v-btn
                            variant="text"
                            class="primary--text ml-2"
                            size="x-small"
                            @click="toggleActive(index)"
                            v-if="item.additionalinfo !== null && item.additionalinfo.length > 0"
                        >
                          <v-icon left size="x-small"
                          >{{ data.show.includes(index) ? 'mdi-chevron-up' :
                              'mdi-chevron-down' }}</v-icon
                          >
                          More Notes
                        </v-btn>
                      </span>
              </p>
              <div class="pb-0 pl-4" v-show="data.show.includes(index)">
                <p class="pt-0 py-2 mb-0 ml-2 font-weight-medium p__text" v-html="item.additionalinfo"></p>
              </div>
            </div>
          </v-card>
          <v-card
              v-if="item.type === 'message'"
              class="elevation-2 mr-4 w-100"
              :color="data.currentUser === item.recipient && item.is_read === false ? '#E3F2FD' : '#fafafa'"
          >
            <v-card-subtitle class="pt-1 pb-0 bottom__padding">
              {{item.name}} sent a message to {{item.recipient}} -
              {{formatTimestampByLocale(item.time)}}
            </v-card-subtitle>
            <p class="font-weight-medium mb-2 py-0 ml-4 top__padding p__text">
              {{item.message}}
            </p>
            <v-card-actions class="py-0">

              <v-spacer></v-spacer>

              <div class="px-5">
                <v-btn
                    v-if="data.currentUser === item.recipient && item.replyToMessage === false && Permissions.checkPermissions(['messages.create'])"
                    size="x-small"
                    variant="text"
                    class="primary--text"
                    @click="item.replyToMessage = true"
                >
                  Reply
                </v-btn>
              </div>

              <div v-if="item.permissions && item.is_read === false">
                <v-btn size="x-small" variant="text" @click="updateMessage(item)">
                  Mark as Read
                </v-btn>
              </div>

              <v-btn v-if="item.is_read === true" size="x-small" variant="text" class="success--text">
                Message Read
              </v-btn>

              <div v-if="data.currentUser === item.recipient && item.is_read === false">
                <v-btn size="x-small" variant="text" @click="updateMessage(item)">
                  Mark as Read
                </v-btn>
              </div>

            </v-card-actions>
            <!-- Reply to message form -->
            <div v-if="item.replyToMessage === true">
              <v-card-actions>
                <v-textarea
                    prepend-inner-icon="mdi-pencil"
                    clearable
                    filled
                    label="Message"
                    v-model="item.newMessage"
                    auto-grow
                ></v-textarea>
              </v-card-actions>

              <v-card-actions>
                <v-btn
                    size="small"
                    variant="elevated"
                    class="error"
                    v-if="item.replyToMessage === true"
                    @click="item.replyToMessage = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    size="small"
                    variant="elevated"
                    class="primary"
                    v-if="item.replyToMessage === true"
                    :loading="data.loading"
                    @click="submitMessage(item)"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          <v-card
              v-if="item.type === 'interaction'"
              class="elevation-2 mr-4 w-100"
          >
            <v-card-subtitle class="pb-0" v-if="item.clientcontact">
              {{item.name}} interacted with {{item.clientcontact}} -
              {{formatTimestampByLocale(item.time)}}
            </v-card-subtitle>
            <v-card-subtitle class="pb-0" v-else>
              {{item.name}} interacted with {{item.claimcontact}} -
              {{formatTimestampByLocale(item.time)}}
            </v-card-subtitle>
            <p class="pt-0 py-2 mb-0 ml-4 font-weight-medium p__text">
              {{item.interaction}}
            </p>
          </v-card>
          <v-card v-if="item.type === 'task'" class="elevation-2 mr-4 w-100">
            <v-card-subtitle v-if="item.createdBy === null" class="pb-0 pt-1">
              {{item.name}} - {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>
            <v-card-subtitle v-else class="pb-0 pt-1">
              {{item.createdBy}} - {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>

            <p  v-if="item.name === 'Make Contact' || item.name === 'Recontact'" class="font-weight-medium pt-0 pb-2 ml-4 mb-0 top__padding p__text">
              {{item.additionalinfo}}
            </p>

            <p  v-else class="font-weight-medium pt-0 pb-2 ml-4 mb-0 top__padding p__text">
              {{item.name}} task completed.
              <span>
                      <v-btn
                          variant="text"
                          class="primary--text ml-2"
                          size="x-small"
                          @click="toggleActive(index)"
                          v-if="item.additionalinfo !== null && item.additionalinfo.length > 0"
                      >
                        <v-icon left size="x-small"
                        >{{ data.show.includes(index) ? 'mdi-chevron-up' :
                            'mdi-chevron-down' }}</v-icon
                        >
                        More Info
                      </v-btn>
                    </span>
            </p>
            <div class="px-4" v-show="data.show.includes(index)">
              <p class="pt-0 py-2 mb-0 ml-2 font-weight-medium p__text">
                {{item.additionalinfo}}
              </p>
            </div>
          </v-card>
          <v-card v-if="item.type === 'file'" class="elevation-2 mr-4 w-100">
            <v-row density="compact" class="pl-4">
              <v-col cols="12">
                <v-img v-show="item.mediumthumbnail !== null"
                       height="200"
                       width="150"
                       :src="grabThumbnail(item.mediumthumbnail)">
                </v-img>
                <v-row density="compact" class="pl-4">
                  <v-col cols="10">
                    <v-card-subtitle v-if="item.uploadedBy !== ''" class="font-weight-medium py-2 pl-0">
                      {{item.name}} - {{formatTimestampByLocale(item.time)}}. Uploaded by {{item.uploadedBy}}
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="font-weight-medium py-2 pl-0">
                      {{item.name}} - {{formatTimestampByLocale(item.time)}}.
                    </v-card-subtitle>
                  </v-col>
                  <v-col cols="2">
                    <v-btn v-if="item.awsKey !== null" icon @click="downloadFile(item)">
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-timeline-item>
      </v-timeline>
      <v-timeline v-else>
        <v-timeline-item size="x-small">
          No Data
        </v-timeline-item>
      </v-timeline>
    </div>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }
  .v-list-item-subtitle {
    font-size: 10px !important;
    color: black !important;
  }

  /* .v-input .v-label {
    font-size: 13px !important;
  } */

  .v-card-subtitle {
    font-size: 10px !important;
    color: black !important;
    text-wrap: wrap!important;
  }
  .v-card-title {
    font-size: 13px !important;
    color: black !important;
    text-wrap: wrap!important;
  }

  #bottom__padding {
    padding-bottom: 0 !important;
  }
  #top__padding {
    padding-top: 0 !important;
  }
  .p__text {
    font-size: 13px !important;
    color: black !important;
    font-family: Roboto, sans-serif;
  }
  #a__text__padding {
    padding-left: 8px !important;
  }
  #card__actions__padding {
    padding-left: 13px !important;
    height: 20px !important;
  }
  .note-span{
    display: inline-block;
  }
</style>